import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-designer/rule";
const STEP = "/reminder-builder/reminder-designer/rule-step";
const TEMPLATE = "/reminder-builder/reminder-library/template";
const RECIPIENT_TYPE = "/reminder-builder/reminder-setup/recipient-type";
const RUN_LOG = "/reminder-builder/reminder-monitor/run-log";

// tbl_rem_rule and its ladder (tbl_rem_rule_step). Write calls, Test run and the user picker are Super Admin only.
const apiReminderRule = {
  create:           (payload)     => axiosClient.post(`${BASE}/create`, payload),
  update:           (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getAll:           (payload)     => axiosClient.post(`${BASE}/get-all`, payload),
  getById:          (id)          => axiosClient.get(`${BASE}/get-by-id/${id}`),
  delete:           (ids)         => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),
  // Preference switches a rule may honour, the audience roles and the viewer's timezone.
  getEditorOptions: ()            => axiosClient.get(`${BASE}/get-editor-options`),
  // Active users for the audience and "Specific users" pickers.
  getUserOptions:   ()            => axiosClient.get(`${BASE}/get-user-options`),
  // { schedule, timezone?, count?, valid_from?, valid_to? } -> { timezone, runs: [{ at, local }] }
  previewSchedule:  (payload)     => axiosClient.post(`${BASE}/preview-schedule`, payload),
  // Evaluates the saved draft now (no case opens, nothing is sent). { cases_shown? }
  testRun:          (id, payload) => axiosClient.post(`${BASE}/test-run/${id}`, payload),
  activate:         (id)          => axiosClient.put(`${BASE}/activate/${id}`),
  pause:            (id)          => axiosClient.put(`${BASE}/pause/${id}`),
  resume:           (id)          => axiosClient.put(`${BASE}/resume/${id}`),
  archive:          (id)          => axiosClient.put(`${BASE}/archive/${id}`),
  clone:            (id)          => axiosClient.post(`${BASE}/clone/${id}`),
  // Evaluates an ACTIVE rule now, outside its schedule, and sends what is due (the result lands in the Run Log).
  runNow:           (id)          => axiosClient.post(`${RUN_LOG}/run-now/${id}`),
  // Cases by status, today's deliveries, last / next run, unsaved draft changes, outdated parts.
  getSummary:       (id)          => axiosClient.get(`${BASE}/get-summary/${id}`),
  // The whole ladder in order; steps without id are created, missing ones removed.
  saveLadder:       (ruleId, steps) => axiosClient.put(`${STEP}/save-ladder/${ruleId}`, { steps }),
  // Templates of a trigger plus the generic ones.
  getTemplateOptions: (triggerFid) => axiosClient.get(`${TEMPLATE}/get-all`, { params: { trigger_fid: triggerFid } }),
  // Recipient types that work with a trigger type.
  getRecipientTypeOptions: (triggerType) => axiosClient.get(`${RECIPIENT_TYPE}/get-all`, { params: { trigger_type: triggerType } }),
};

export default apiReminderRule;
